import pulse from '@finn-no/pulse-sdk';
import { IconCheck16 } from '@warp-ds/icons/react/check-16';
import { Box, Button } from '@warp-ds/react';
import type React from 'react';
import { SolgtComLogo } from './SolgtComLogo.js';

export const SolgtComBox: React.FC = () => {
  const trackClick = () => {
    pulse.trackEvent({
      name: 'Continue with Solgt.com',
      type: 'Click',
      intent: 'Open',
      object: {
        type: 'UIElement',
        elementType: 'Button',
        id: 'solgtComBtn',
      },
      vertical: {
        name: 'mobility',
      },
    });
  };

  return (
    <Box bordered className="flex flex-col justify-between h-full">
      <div className="md:mb-16 flex-grow">
        <div className="mb-24">
          <SolgtComLogo />
        </div>
        <h2 className="h3 mb-8 flex items-center">Garantisalg via Solgt.com</h2>
        <p className="h4 mb-16">Solgt.com tilbyder en nem, hurtig, sikker og uforpligtende måde at sælge din bil på.</p>
        <p className="mb-24">
          Få en gratis og uforpligtende tilbudspris på din bil indenfor 24 timer. Du er garanteret et salg og pengene på
          din konto indenfor 3 hverdage efter handel.
        </p>
        <div className="flex-col">
          <div className="flex cols-2 items-center mb-8">
            <IconCheck16 className="s-icon-positive mr-8" />
            Det er gratis og uforpligtende
          </div>
          <div className="flex cols-2 items-center mb-8">
            <IconCheck16 className="s-icon-positive mr-8" />
            Autoriserede landsækkende forhandlere
          </div>
          <div className="flex cols-2 items-center mb-8">
            <IconCheck16 className="s-icon-positive mr-8" />
            Garanteret salg og/med sikker betaling
          </div>
        </div>
      </div>
      <div className="mt-auto mb-16">
        <Button href="/mobility/guaranteed-sale?origin=dba_syi_upsell_modal" fullWidth onClick={trackClick}>
          Fortsæt med Solgt.com
        </Button>
      </div>
      <p className="text-12 mt-4">
        Kun personbiler på fuld afgift fra og med årgang 2000. Dvs. ingen ældre biler, nuværende og tidligere taxa'er,
        leasingbiler, varebiler eller biler uden afgift.
      </p>
    </Box>
  );
};
